module.exports = __webpack_public_path__ + "img/1451094103.3d47a550.jpg";